import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { mainGoldFont } from '../fontStyles';

export default class PaytableContent extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.currentFrame = 1;
    this.addListeners();
  }

  addListeners() {
    GlobalDispatcher.add('paytable:backClick', this.reset, this);
    GlobalDispatcher.add('paytable:changePage', this.changeFrame, this);
  }

  update() {
    const title = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_0`);
    title.style = { ...title.style, ...mainGoldFont };

    switch (this.currentFrame) {
      case 3:
        const count = this.children[0].getChildByName(`paytable_p2_count0`);
        const coeff = this.children[0].getChildByName(`paytable_p2_coefs0`);
        coeff.text = EntryPoint.GameModel.paytableInfo[1][EntryPoint.GameModel.paytableInfo[1].length - 1];
        count.style = { ...count.style, ...mainGoldFont };
        coeff.style = { ...coeff.style, ...mainGoldFont };
        for (let i = 1; i <= 2; i++) {
          const text = this.children[0].getChildByName(`paytable_2_${i}`);
          text.style = { ...text.style, ...mainGoldFont };
          text.fitSize();
        }
        break;
      case 4:
        for (let i = 1; i <= 4; i++) {
          const count = this.children[0].getChildByName(`paytable_p3_count${i - 1}`);
          const coeff = this.children[0].getChildByName(`paytable_p3_coefs${i - 1}`);
          coeff.text = EntryPoint.GameModel.paytableInfo[i + 1][EntryPoint.GameModel.paytableInfo[i + 1].length - 1];
          count.style = { ...count.style, ...mainGoldFont };
          coeff.style = { ...coeff.style, ...mainGoldFont };
        }
        break;
      case 5:
        for (let i = 0; i <= 3; i++) {
          const count = this.children[0].getChildByName(`paytable_p4_count${i}`);
          const coeff = this.children[0].getChildByName(`paytable_p4_coefs${i}`);
          coeff.text = EntryPoint.GameModel.paytableInfo[i + 6][EntryPoint.GameModel.paytableInfo[i + 6].length - 1];
          count.style = { ...count.style, ...mainGoldFont };
          coeff.style = { ...coeff.style, ...mainGoldFont };
        }
        break;
      case 6:
        const text = this.children[0].getChildByName(`paytable_5_1`);
        text.style = { ...text.style, ...mainGoldFont };
        break;
    }
  }

  setTextsStyle() {
    for (let i = 0; i <= 8; i++) {
      const text = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_${i}`);
      if (text) {
        text.style = { ...text.style, ...mainGoldFont }
      }
    }
  }

  changeFrame(event) {
    this.currentFrame = event.params || 1;
    this.goToFrame(this.currentFrame);
    this.update();
    // this.setTextsStyle();
  }

  reset() {
    this.currentFrame = 1;
    this.goToFrame(this.currentFrame);
    this.update();
  }

  destroy() {
    GlobalDispatcher.remove('paytable:backClick', this.reset, this);
    GlobalDispatcher.remove('paytable:changePage', this.changeFrame, this);
    super.destroy();
  }
}
